import { Component, OnInit, OnChanges, Input } from '@angular/core';

@Component({
  selector: 'app-turns-reports-list-card',
  templateUrl: './turns-reports-list-card.component.html',
  styleUrls: ['./turns-reports-list-card.component.scss']
})
export class TurnsReportsListCardComponent implements OnInit, OnChanges {

  @Input() data;
  tableData;
  turnDeskStatusOrder;
  turnDeskNameOrder;
  centerNameOrder;
  smsTurnsPickedOrder;
  ticketTurnsPickedOrder;
  totalTurnsAttendedOrder;
  totalTurnsCancelledOrder;
  totalTurnsPassedOrder;
  turnsWaitAverageSecsOrder;
  appTurnsPickedOrder;
  turnsDateOrder;

  constructor() { }

  ngOnInit() {
    this.wrapData();
  }

  ngOnChanges() {
    this.wrapData();
  }

  public wrapData() {
    if (this.data) {
      this.resetSortOrders();
    }
  }

  public resetSortOrders() {
    this.turnDeskStatusOrder = 0;
    this.turnDeskNameOrder = 0;
    this.centerNameOrder = 0;
    this.smsTurnsPickedOrder = 0;
    this.ticketTurnsPickedOrder = 0;
    this.totalTurnsAttendedOrder = 0;
    this.totalTurnsCancelledOrder = 0;
    this.totalTurnsPassedOrder = 0;
    this.turnsWaitAverageSecsOrder = 0;
    this.appTurnsPickedOrder = 0;
    this.turnsDateOrder = 0;
  }

  public sortBy(attribute) {
    switch (attribute) {
      case 'turnDeskStatus':
        this.turnDeskStatusOrder = (this.turnDeskStatusOrder === 0) ? 1 : (this.turnDeskStatusOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.TurnDeskStatus = a.TurnDeskStatus ? a.TurnDeskStatus : ' ';
            b.TurnDeskStatus = b.TurnDeskStatus ? b.TurnDeskStatus : ' ';
            return (a.TurnDeskStatus.toUpperCase() < b.TurnDeskStatus.toUpperCase()) ? -this.turnDeskStatusOrder : (a.TurnDeskStatus.toUpperCase() > b.TurnDeskStatus.toUpperCase()) ? this.turnDeskStatusOrder : 0;
          });
        break;
      case 'turnDeskName':
        this.turnDeskNameOrder = (this.turnDeskNameOrder === 0) ? 1 : (this.turnDeskNameOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.TurnDeskName = a.TurnDeskName ? a.TurnDeskName : ' ';
            b.TurnDeskName = b.TurnDeskName ? b.TurnDeskName : ' ';
            return (a.TurnDeskName.toUpperCase() < b.TurnDeskName.toUpperCase()) ? -this.turnDeskNameOrder : (a.TurnDeskName.toUpperCase() > b.TurnDeskName.toUpperCase()) ? this.turnDeskNameOrder : 0;
          });
        break;
      case 'centerName':
        this.centerNameOrder = (this.centerNameOrder === 0) ? 1 : (this.centerNameOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.CenterName = a.CenterName ? a.CenterName : ' ';
            b.CenterName = b.CenterName ? b.CenterName : ' ';
            return (a.CenterName.toUpperCase() < b.CenterName.toUpperCase()) ? -this.centerNameOrder : (a.CenterName.toUpperCase() > b.CenterName.toUpperCase()) ? this.centerNameOrder : 0;
          });
        break;
      case 'smsTurnsPicked':
        this.smsTurnsPickedOrder = (this.smsTurnsPickedOrder === 0) ? 1 : (this.smsTurnsPickedOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.SmsTurnsPicked = a.SmsTurnsPicked ? a.SmsTurnsPicked : a.SmsTurnsPicked === 0 ? a.SmsTurnsPicked : ' ';
            b.SmsTurnsPicked = b.SmsTurnsPicked ? b.SmsTurnsPicked : b.SmsTurnsPicked === 0 ? b.SmsTurnsPicked : ' ';
            return (a.SmsTurnsPicked === '-' ? 0 > b.SmsTurnsPicked : b.SmsTurnsPicked === '-' ? a.SmsTurnsPicked > 0 : a.SmsTurnsPicked < b.SmsTurnsPicked) ? -this.smsTurnsPickedOrder : (a.SmsTurnsPicked > b.SmsTurnsPicked) ? this.smsTurnsPickedOrder : 0;
          });
        break;
      case 'ticketTurnsPicked':
        this.ticketTurnsPickedOrder = (this.ticketTurnsPickedOrder === 0) ? 1 : (this.ticketTurnsPickedOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.TicketTurnsPicked = a.TicketTurnsPicked ? a.TicketTurnsPicked : a.TicketTurnsPicked === 0 ? a.TicketTurnsPicked : ' ';
            b.TicketTurnsPicked = b.TicketTurnsPicked ? b.TicketTurnsPicked : b.TicketTurnsPicked === 0 ? b.TicketTurnsPicked : ' ';
            return (a.TicketTurnsPicked === '-' ? 0 > b.TicketTurnsPicked : b.TicketTurnsPicked === '-' ? a.TicketTurnsPicked > 0 : a.TicketTurnsPicked < b.TicketTurnsPicked) ? -this.ticketTurnsPickedOrder : (a.TicketTurnsPicked > b.TicketTurnsPicked) ? this.ticketTurnsPickedOrder : 0;
          });
        break;
      case 'totalTurnsAttended':
        this.totalTurnsAttendedOrder = (this.totalTurnsAttendedOrder === 0) ? 1 : (this.totalTurnsAttendedOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.TotalTurnsAttended = a.TotalTurnsAttended ? a.TotalTurnsAttended : a.TotalTurnsAttended === 0 ? a.TotalTurnsAttended : ' ';
            b.TotalTurnsAttended = b.TotalTurnsAttended ? b.TotalTurnsAttended : b.TotalTurnsAttended === 0 ? b.TotalTurnsAttended : ' ';
            return (a.TotalTurnsAttended === '-' ? 0 > b.TotalTurnsAttended : b.TotalTurnsAttended === '-' ? a.TotalTurnsAttended > 0 : a.TotalTurnsAttended < b.TotalTurnsAttended) ? -this.totalTurnsAttendedOrder : (a.TotalTurnsAttended > b.TotalTurnsAttended) ? this.totalTurnsAttendedOrder : 0;
          });
        break;
      case 'totalTurnsCancelled':
        this.totalTurnsCancelledOrder = (this.totalTurnsCancelledOrder === 0) ? 1 : (this.totalTurnsCancelledOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.TotalTurnsCancelled = a.TotalTurnsCancelled ? a.TotalTurnsCancelled : a.TotalTurnsCancelled === 0 ? a.TotalTurnsCancelled : ' ';
            b.TotalTurnsCancelled = b.TotalTurnsCancelled ? b.TotalTurnsCancelled : b.TotalTurnsCancelled === 0 ? b.TotalTurnsCancelled : ' ';
            return (a.TotalTurnsCancelled === '-' ? 0 > b.TotalTurnsCancelled : b.TotalTurnsCancelled === '-' ? a.TotalTurnsCancelled > 0 : a.TotalTurnsCancelled < b.TotalTurnsCancelled) ? -this.totalTurnsCancelledOrder : (a.TotalTurnsCancelled > b.TotalTurnsCancelled) ? this.totalTurnsCancelledOrder : 0;
          });
        break;
      case 'totalTurnsPassed':
        this.totalTurnsPassedOrder = (this.totalTurnsPassedOrder === 0) ? 1 : (this.totalTurnsPassedOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.TotalTurnsPassed = a.TotalTurnsPassed ? a.TotalTurnsPassed : a.TotalTurnsPassed === 0 ? a.TotalTurnsPassed : ' ';
            b.TotalTurnsPassed = b.TotalTurnsPassed ? b.TotalTurnsPassed : b.TotalTurnsPassed === 0 ? b.TotalTurnsPassed : ' ';
            return (a.TotalTurnsPassed === '-' ? 0 > b.TotalTurnsPassed : b.TotalTurnsPassed === '-' ? a.TotalTurnsPassed > 0 : a.TotalTurnsPassed < b.TotalTurnsPassed) ? -this.totalTurnsPassedOrder : (a.TotalTurnsPassed > b.TotalTurnsPassed) ? this.totalTurnsPassedOrder : 0;
          });
        break;
      case 'turnsWaitAverageSecs':
        this.turnsWaitAverageSecsOrder = (this.turnsWaitAverageSecsOrder === 0) ? 1 : (this.turnsWaitAverageSecsOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.TurnsWaitAverageSecs = a.TurnsWaitAverageSecs ? a.TurnsWaitAverageSecs : a.TurnsWaitAverageSecs === 0 ? a.TurnsWaitAverageSecs : ' ';
            b.TurnsWaitAverageSecs = b.TurnsWaitAverageSecs ? b.TurnsWaitAverageSecs : b.TurnsWaitAverageSecs === 0 ? b.TurnsWaitAverageSecs : ' ';
            return (a.TurnsWaitAverageSecs === '-' ? 0 > b.TurnsWaitAverageSecs : b.TurnsWaitAverageSecs === '-' ? a.TurnsWaitAverageSecs > 0 : a.TurnsWaitAverageSecs < b.TurnsWaitAverageSecs) ? -this.turnsWaitAverageSecsOrder : (a.TurnsWaitAverageSecs > b.TurnsWaitAverageSecs) ? this.turnsWaitAverageSecsOrder : 0;
          });
        break;
      case 'appTurnsPicked':
        this.appTurnsPickedOrder = (this.appTurnsPickedOrder === 0) ? 1 : (this.appTurnsPickedOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.AppTurnsPicked = a.AppTurnsPicked ? a.AppTurnsPicked : a.AppTurnsPicked === 0 ? a.AppTurnsPicked : ' ';
            b.AppTurnsPicked = b.AppTurnsPicked ? b.AppTurnsPicked : b.AppTurnsPicked === 0 ? b.AppTurnsPicked : ' ';
            return (a.AppTurnsPicked === '-' ? 0 > b.AppTurnsPicked : b.AppTurnsPicked === '-' ? a.AppTurnsPicked > 0 : a.AppTurnsPicked < b.AppTurnsPicked) ? -this.appTurnsPickedOrder : (a.AppTurnsPicked > b.AppTurnsPicked) ? this.appTurnsPickedOrder : 0;
          });
        break;
      case 'turnsDate':
        this.turnsDateOrder = (this.turnsDateOrder === 0) ? 1 : (this.turnsDateOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.TurnsDate = a.TurnsDate ? a.TurnsDate : ' ';
            b.TurnsDate = b.TurnsDate ? b.TurnsDate : ' ';
            return (a.TurnsDate === '-' ? 0 > b.TurnsDate : b.TurnsDate === '-' ? a.TurnsDate > 0 : a.TurnsDate < b.TurnsDate) ? -this.turnsDateOrder : (a.TurnsDate > b.TurnsDate) ? this.turnsDateOrder : 0;
          });
        break;
    }
  }

  public getTurnDeskStatusColor(turnDeskStatus) {
    switch (turnDeskStatus) {
      case 'ACTIVE':
        return 'green';
      case 'INACTIVE':
        return 'red';
      case 'DELETED':
        return 'gray';
    }
  }
  public getCustomerEvaluationIcon(customerEvaluation) {
    switch (customerEvaluation) {
      case 'BAD':
        return 'far fa-frown';
      case 'NEUTRAL':
        return 'far fa-meh';
      case 'GOOD':
        return 'far fa-smile';
    }
  }

}
